<script>
export default {
  name: 'ServicesComponent',
  data: function () {
    return {
    }
  }
}
</script>
<template>
  <section  class="white">

    <!-- <header>
      <h1>Rad Repair, Machine Shop Service and Earth Moving in Labrador West</h1>
      <h5>History of who we are and what we do</h5>
      <div class="quote">Labrador West #1 Industrial Radiator Repair Shop</div>
    </header> -->

    <!-- START PARALLAX HEADER -->
    <v-parallax src="/static/img/parallax-services.jpg" height="300">
      <v-layout column>
            <!-- <header>
              <h1>Products &amp; Services</h1>
              <h5>History of who we are and what we do</h5>
              <div class="quote">Labrador West #1 Industrial Radiator Repair Shop</div>
            </header> -->
        </v-layout>
    </v-parallax>
    <!-- END PARALLAX HEADER -->

    <article>
      <v-container grid-list-lg class="maxed">
        <v-layout row wrap>
          <v-flex xs12>

            <section>
              <div class="quote">We are located in Wabush Industrial Park</div>
            </section>
            <section>
              <!-- <h2>Serving Various Sectors of Our Economy</h2>
              <p>As an original equipment manufacturer (OEM) repair facility, we offer a 1-year warranty on our work. Maybe that's why some of the business sectors that we have catered to in the past include:
              </p>
              <ul>
                <li><v-icon>home</v-icon>Industrial</li>
                <lI><v-icon>home</v-icon>Commercial</li>
                <li><v-icon>home</v-icon>Transit bus fleets and corporations</li>
                <li><v-icon>home</v-icon>Trucking and transportation companies</li>
                <li><v-icon>home</v-icon>Mining companies</li>
                <li><v-icon>home</v-icon>Municipalities</li>
              </ul>
              <p>We also have a Caterpillar 920 loader, 2 dump trucks, a tractor/forklift, and 2 trailers. As you can see, LCR Plus Ltd. in Labrador West is much more than an industrial radiator repair shop. Contact us for more information or an estimate.</p>
              <div class="quote">Some of the brands we are proud to work with</div> -->
              <h2>Brands</h2>
              <ul>
                <li>Mesabi®</li>
                <lI>Sprectra Premium™</li>
                <li>Toromont®</li>
              </ul>

            </section>
          </v-flex>
        </v-layout>
      </v-container>
    </article>
  </section>
</template>



// WEBPACK FOOTER //
// src/components/Services.vue